/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { Router, NavigationEnd  } from '@angular/router';


@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private router: Router, private analytics: AnalyticsService, private seoService: SeoService, private authService: NbAuthService) {
  }

  ngOnInit(): void {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.url;
        console.log('Current URL:', url);

        this.checkAuth(url);
      }
    });

    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        localStorage.setItem('authToken', token.getValue());
      }
    });

    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  };

  logout() {
    this.authService.logout('email').subscribe(() => {
      console.log("Logout");
    // clear custom storage
      localStorage.removeItem('authToken');
      sessionStorage.clear();

    // redirect
      this.router.navigate(['/auth/login'], {
        replaceUrl: true
      });
    });
  };

  checkAuth(url: string) {
    const token = localStorage.getItem('authToken');
    console.log(token)

    if (!token && !url.includes('login')) {
      this.router.navigate(['/auth/login'], { replaceUrl: true });
    }
  };
}
